import { Array, Boolean, InstanceOf, Literal, Number, Partial, Record, String, Union, Unknown } from "runtypes";
export const ConnectionQuery = Record({
    browserID: String,
    tabID: String,
});
export const ConnectionLocation = Record({
    origin: String,
    browserID: String,
    tabID: String,
});
export const ConnectionSave = Union(ConnectionLocation, Record({
    type: Union(Literal("connected"), Literal("disconnected")),
    timestamp: InstanceOf(Date),
}));
export const UpdateMessage = Record({
    type: Literal("update"),
    location: Unknown,
    width: Number,
    height: Number,
    elements: Array(Record({
        top: Number,
        bottom: Number,
        tagName: String,
    }).And(Partial({ id: String, text: String }))),
}).And(Partial({
    visible: Boolean,
    IPv4: String,
    IPv6: String,
}));
export const UpdateSave = Union(ConnectionLocation, UpdateMessage, Record({
    timestamp: InstanceOf(Date),
}), Partial({
    email: String,
}));
export const LoginMessage = Record({
    type: Literal("login"),
    googleToken: String,
});
export const LoginSave = Union(ConnectionLocation, Record({
    type: Literal("login"),
    timestamp: InstanceOf(Date),
    email: String,
}));
//# sourceMappingURL=index.js.map